<template>
  <modal @close_modal="close" :title="file ? file.name : ''" :loading="loading">
    <template v-slot:content>
      <div v-if="isImage" class="file-image-wrap">
        <img :src="file.path" :alt="file.name" class="file-image" />
      </div>
      <template v-else>
        <div v-if="loading" class="text-body-2 text--secondary">
          {{ $t('models_and_train_configs.train_log_raw_loading') }}
        </div>
        <div v-else-if="error" class="text-body-2 error--text">
          {{ error }}
        </div>
        <pre v-else class="file-text">{{ text }}</pre>
      </template>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/Modal';

const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];
const MAX_TEXT_CHARS = 512 * 1024;

export default {
  name: 'ModelFilePreviewModal',
  components: { Modal },
  props: {
    file: { required: true },
  },
  data() {
    return {
      loading: false,
      text: '',
      error: null,
    };
  },
  computed: {
    extension() {
      if (!this.file || !this.file.name) {
        return '';
      }
      const parts = this.file.name.split('.');
      return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
    },
    isImage() {
      return IMAGE_EXTENSIONS.includes(this.extension);
    },
  },
  mounted() {
    if (!this.isImage) {
      this.loadText();
    }
  },
  methods: {
    close() {
      this.$emit('close_modal');
    },
    async loadText() {
      this.loading = true;
      this.error = null;
      this.text = '';
      try {
        const res = await fetch(this.file.path);
        if (!res.ok) {
          this.error = this.$t('models_and_train_configs.train_log_raw_error');
          return;
        }
        const raw = await res.text();
        if (raw.length > MAX_TEXT_CHARS) {
          const start = raw.length - MAX_TEXT_CHARS;
          this.text =
            '…\n' +
            raw.slice(start) +
            '\n\n' +
            this.$t('models_and_train_configs.train_log_raw_truncated');
        } else {
          this.text = raw;
        }
      } catch {
        this.error = this.$t('models_and_train_configs.train_log_raw_error');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.file-text {
  max-height: min(60vh, 500px);
  overflow: auto;
  margin: 0;
  padding: 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
    'Liberation Mono', 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 4px;
}
.file-image-wrap {
  max-height: min(70vh, 640px);
  overflow: auto;
  text-align: center;
}
.file-image {
  max-width: 100%;
  height: auto;
}
</style>
